import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { useBackendAuthenticated } from "@/hooks/useBackendAuthenticated";

export const SystemLogEntrySchema = z.object({
  id: z.string(),
  service: z.string(),
  level: z.string(),
  message: z.string(),
  data: z.record(z.unknown()).nullable(),
  createdAt: z.string(),
});

export type SystemLogEntry = z.infer<typeof SystemLogEntrySchema>;

const SystemLogsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(SystemLogEntrySchema),
  hasMore: z.boolean(),
});

export function useSystemLogs({
  limit = 100,
  offset = 0,
  service,
  level,
}: {
  limit?: number;
  offset?: number;
  service?: string;
  level?: string;
}) {
  const backend = useBackendAuthenticated();
  return useQuery({
    queryKey: ["system-logs", limit, offset, service, level],
    queryFn: async () => {
      const params: Record<string, string | number> = { limit, offset };
      if (service) params.service = service;
      if (level)   params.level   = level;
      const json = await backend({ method: "GET", url: "/api/v1/system-logs", params });
      return SystemLogsResponseSchema.parse(json);
    },
    refetchOnWindowFocus: false,
  });
}
